<!-- md:shadow-smTop -->
<footer #navbar class="w-full dark:sm:bg-light-black md:bg-transparent px-8">
  <div class="flex flex-col items-center justify-start m-auto xl:flex-row">
    <div class="order-2 left-content xl:order-1 w-72 m-auto text-center">
      <h5
        class="text-xs font-semibold text-light-black dark:text-white opacity-60"
        data-track="member-anonymous-footer-copyright-text"
        [innerHTML]="
          'general.footerCopyright' | translate : { year: currentYear }
        "
      ></h5>
    </div>
    <nav
      class="items-center justify-between order-1 block w-full md:justify-end xl:space-x-6 xl:order-2 xl:flex"
    >
      <ul class="footer-nav text-center xl:flex flex-wrap">
        <li class="ml-4">
          <a
            class="text-light-black dark:text-white"
            href="https://support.crowdtap.com/"
            target="_blank"
            data-track="member-anonymous-footer-help-link"
            >{{ 'nav.help' | translate }}</a
          >
        </li>
        <li>
          <a
            class="text-light-black dark:text-white"
            routerLink="/terms-of-service"
            target="_blank"
            data-track="member-anonymous-footer-terms-link"
            >{{ 'nav.termsOfService' | translate }}</a
          >
        </li>
        <li>
          <a
            class="text-light-black dark:text-white"
            routerLink="/privacy-policy"
            target="_blank"
            data-track="member-anonymous-footer-privacy-link"
            >{{ 'nav.privacyPolicy' | translate }}</a
          >
        </li>
        <li>
          <a
            class="text-light-black dark:text-white"
            routerLink="/notice-of-financial-incentive"
            target="_blank"
            data-track="member-anonymous-footer-financial-incentive-link"
            >{{ 'nav.noticeOfFinancialIncentive' | translate }}</a
          >
        </li>
        <li>
          <a
            class="text-light-black dark:text-white"
            routerLink="/cookie-policy"
            target="_blank"
            data-track="member-anonymous-footer-cookie-link"
            >{{ 'nav.cookiesPolicy' | translate }}</a
          >
        </li>
        <li
          class="has-icon inline-flex items-end pt-2 xl:items-center xl:pt-0 xl:flex"
        >
          <img src="/assets/icons/svg/privacy.svg" />
          <a
            class="text-light-black dark:text-white pt-1"
            href="https://crowdtap.formcrafts.com/privacyrequest"
            target="_blank"
            data-track="member-anonymous-footer-privacy-choices-link"
            >{{ 'nav.privacyChoices' | translate }}</a
          >
        </li>
        <li>
          <a
            class="text-light-black dark:text-white"
            routerLink="/accessibility-statement"
            target="_blank"
            data-track="member-anonymous-footer-accessibility-link"
            >{{ 'nav.accessibilityStatement' | translate }}</a
          >
        </li>
      </ul>

      <ul class="py-6 social-nav xl:py-0 pl-6 xl:pl-0">
        <li>
          <a
            href="http://facebook.com/Crowdtap"
            target="_blank"
            data-track="member-anonymous-footer-facebook-btn"
          >
            <svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.4189 26H15.0147H13H11.0069H6.58109C2.94816 26 0 23.0518 0 19.4189V6.58109C0 2.94816 2.94816 0 6.58109 0H19.4189C23.0518 0 26 2.94816 26 6.58109V19.4189C26 23.0518 23.0518 26 19.4189 26Z"
                fill="#444444"
              />
              <path
                d="M11.6693 8.33205V10.9498H9V14.3889H11.6693V22.99H14.9587V14.3889H17.4094L17.876 10.9498H14.9587V8.71937C14.9587 7.77779 15.3661 6.86292 16.6713 6.86292H18V3.93801C18 3.93801 16.7953 3.70428 15.6437 3.70428C13.2402 3.70428 11.6693 5.34704 11.6693 8.33205Z"
                fill="white"
              />
            </svg>
          </a>
        </li>
        <li>
          <a
            href="http://twitter.com/Crowdtap"
            target="_blank"
            data-track="member-anonymous-footer-twitter-btn"
          >
            <svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.4189 26H6.58109C2.94816 26 0 23.0518 0 19.4189V6.58109C0 2.94815 2.94816 0 6.58109 0H19.4189C23.0518 0 26 2.94815 26 6.58109V19.4189C26 23.0518 23.0518 26 19.4189 26Z"
                fill="#444444"
              />
              <path
                d="M20.0892 8.69323C19.6423 8.89506 19.1521 9.0176 18.6764 9.09689C18.907 9.06085 19.2386 8.64277 19.3756 8.47698C19.5774 8.2247 19.7504 7.92916 19.8441 7.61921C19.8585 7.59758 19.8657 7.56154 19.8441 7.54713C19.8153 7.53271 19.7936 7.53991 19.772 7.55433C19.2386 7.84266 18.6836 8.0517 18.0925 8.19587C18.042 8.21028 18.006 8.19586 17.9772 8.16703C17.9267 8.10937 17.8835 8.05891 17.833 8.01566C17.5879 7.80662 17.3212 7.64083 17.0185 7.51829C16.622 7.35971 16.1967 7.28763 15.7715 7.31646C15.3606 7.3453 14.9569 7.46063 14.5893 7.64804C14.2217 7.84266 13.8973 8.10937 13.6378 8.42653C13.3711 8.7581 13.1693 9.15455 13.0684 9.56542C12.9675 9.96908 12.9747 10.3655 13.0395 10.7692C13.0468 10.8341 13.0395 10.8485 12.9819 10.8341C10.6753 10.4881 8.76508 9.66634 7.21531 7.90033C7.15044 7.82104 7.1144 7.82104 7.05673 7.90754C6.37916 8.92389 6.71074 10.5602 7.5541 11.3675C7.66943 11.4756 7.78476 11.5837 7.9073 11.6774C7.86405 11.6846 7.2946 11.627 6.79724 11.3675C6.73236 11.3242 6.69632 11.3458 6.68911 11.4251C6.6819 11.5333 6.68911 11.6342 6.71074 11.7567C6.84048 12.7875 7.5541 13.7462 8.53441 14.1138C8.64974 14.1643 8.77949 14.2075 8.90203 14.2291C8.67858 14.2796 8.44791 14.3156 7.81359 14.2652C7.7343 14.2508 7.70547 14.2868 7.7343 14.3661C8.21725 15.678 9.25523 16.0672 10.0265 16.2907C10.1274 16.3123 10.2355 16.3123 10.3365 16.3339C10.3293 16.3411 10.322 16.3411 10.3148 16.3555C10.0553 16.7448 9.16153 17.0403 8.75066 17.1845C7.9938 17.4512 7.17206 17.5665 6.37195 17.4872C6.2422 17.4656 6.22058 17.4728 6.18454 17.4872C6.1485 17.5089 6.17733 17.5377 6.22058 17.5737C6.38637 17.6819 6.54495 17.7756 6.71794 17.8693C7.22252 18.136 7.75593 18.3522 8.31096 18.5036C11.1726 19.2965 14.3875 18.7126 16.5355 16.579C18.2222 14.9067 18.8133 12.5929 18.8133 10.279C18.8133 10.1853 18.9214 10.1421 18.9863 10.0916C19.426 9.76004 19.7792 9.3708 20.1036 8.9311C20.1757 8.83018 20.1757 8.74369 20.1757 8.70765C20.1757 8.70044 20.1757 8.69323 20.1757 8.69323C20.1468 8.65719 20.1468 8.66439 20.0892 8.69323Z"
                fill="white"
              />
            </svg>
          </a>
        </li>
        <li>
          <a
            href="http://instagram.com/crowdtap"
            target="_blank"
            data-track="member-anonymous-footer-instagram-btn"
          >
            <svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.4189 26H6.58109C2.94816 26 0 23.0582 0 19.4171V6.58292C0 2.94897 2.94816 0 6.58109 0H19.4189C23.0518 0 26 2.94897 26 6.58292V19.4243C26 23.0582 23.0518 26 19.4189 26Z"
                fill="#444444"
              />
              <path
                d="M16.9829 8.18488C16.4928 8.18488 16.1035 8.58133 16.1035 9.06428C16.1035 9.54723 16.5 9.94368 16.9829 9.94368C17.4731 9.94368 17.8623 9.54723 17.8623 9.06428C17.8623 8.58133 17.4731 8.18488 16.9829 8.18488Z"
                fill="white"
              />
              <path
                d="M13.0616 9.31641C11.0145 9.31641 9.35657 10.982 9.35657 13.0225C9.35657 15.0701 11.0217 16.7285 13.0616 16.7285C15.1087 16.7285 16.7666 15.0629 16.7666 13.0225C16.7666 10.982 15.1015 9.31641 13.0616 9.31641ZM13.0616 15.4018C11.7497 15.4018 10.6901 14.3347 10.6901 13.0297C10.6901 11.7174 11.7569 10.6575 13.0616 10.6575C14.3735 10.6575 15.4331 11.7246 15.4331 13.0297C15.4331 14.3347 14.3735 15.4018 13.0616 15.4018Z"
                fill="white"
              />
              <path
                d="M16.0021 20.5553H9.99049C7.49645 20.5553 5.47095 18.5292 5.47095 16.0345V10.0212C5.47095 7.52644 7.49645 5.50037 9.99049 5.50037H16.0021C18.4962 5.50037 20.5217 7.52644 20.5217 10.0212V16.0345C20.5289 18.5292 18.4962 20.5553 16.0021 20.5553ZM9.99049 6.91357C8.27494 6.91357 6.88376 8.30514 6.88376 10.0212V16.0345C6.88376 17.7505 8.27494 19.1421 9.99049 19.1421H16.0021C17.7177 19.1421 19.1089 17.7505 19.1089 16.0345V10.0212C19.1089 8.30514 17.7177 6.91357 16.0021 6.91357H9.99049Z"
                fill="white"
              />
            </svg>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</footer>
